import { useParams } from 'react-router-dom'
import EditCourseForm from './EditCourseForm'
import { useGetCoursesQuery } from './coursesApiSlice'
import { useGetUsersQuery } from '../users/usersApiSlice'
import useAuth from '../../hooks/useAuth'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditCourse = () => {
    useTitle('techCourses: Edit Course')

    const { id } = useParams()

    const { username, isAdmin } = useAuth()

    const { course } = useGetCoursesQuery("coursesList", {
        selectFromResult: ({ data }) => ({
            course: data?.entities[id]
        }),
    })


    if (!course) return <PulseLoader color={"#FFF"} />


    if (!isAdmin) {
            return <p className="errmsg">No access</p>
    }

    const content = <EditCourseForm course={course} />

    return content
}
export default EditCourse